export default __webpack_public_path__ + "static/media/WeatherWidgetLegendDesktop.b0ec4268.svg";